import React from 'react'
import {sortBy} from 'lodash'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'

import OrganizationalUnitModal from './modal/OrganizationalUnitModal'
import DeleteModal from '../../components/DeleteModal'

import * as unitService from '../../services/organizational-units-service'

export default class Organizationalunits extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.buttonFormatter = this.buttonFormatter.bind(this)
    this.deleteId = this.deleteId.bind(this)

    this.state = { 
      unit: undefined
    }
  }
 
  deleteId(id) {
    unitService.deleteUnit(id).then(() => this.props.refresh()
    )
  }

  buttonFormatter(cell, row, id) {
    return (
      <div className='row-actions'>
        <OrganizationalUnitModal 
          title="Wijzigen organisatorische eenheid"
          text="Wilt u deze organisatorische eenheid wijzigen?"
          modalbttext=" Wijzigen"
          id={row.id} 
          reload={() => this.props.refresh()} />

        <DeleteModal 
          title="Verwijderen organisatorische eenheid"
          text="Wilt u deze organisatorische eenheid verwijderen? Let op: lopende of voltooide scans van deze organisatorische eenheid worden dan ook uit BrandWijzer verwijderd."
          className='delete-entry action-btn'
          delete={() => this.deleteId(row.id)}>
        </DeleteModal>
      </div>
    )
  }

  render() {
    function headerFormatter(column, colIndex, { sortElement }) {
      return (
        <span className="sortable-inner">
          <span className="text">{column.text}</span>
          {sortElement}
        </span>
      )
    }

    function contentFormatter(cell, row) {
      return (
        <span className="text">{cell}</span>
      )
    }

    const { units } = this.props

    const columns = [{
      dataField: 'locationName',
      text: 'Locatie',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'name',
      text: 'Organisatorische eenheid',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'numberOfCollaborators',
      text: 'Gekoppelde medewerkers',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'button',
      text: ' ',
      formatter: this.buttonFormatter
    }]

    const paginationOptions = paginationFactory({
        sizePerPageList: [{
        value: 20
      }],
      paginationSize: 5,
      hideSizePerPage: true,
      alwaysShowAllBtns: true
    })

    return (
      <div className="tab-inner table-page units">
        <BootstrapTable
          keyField='id'
          data={sortBy(units, ["locationName", "name"])}
          columns={columns}
          bordered={ false }
          striped
          hover
          condensed
          pagination={ paginationOptions } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Organizationalunits/index.js